import React from 'react';
import { $Grid } from './styles';
export const Grid = (props) => React.createElement($Grid, { ...props });
